import { Component, OnDestroy, OnInit } from '@angular/core';
import { ZoneService } from '../../services/zone.service';
import { Zone } from '../../models/zone';
import { Sensor, SensorTypes } from '../../models/sensor';
import { Router, ActivatedRoute } from '@angular/router';
import { DataService } from '../../services/data.service';
import { Subscription } from 'rxjs';
import { AddDialogComponent } from'../clients/add-dialog/add-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { ApiService } from "src/app/services/api.service";
import { Location } from '@angular/common'
import { AuthService } from 'src/app/services/auth.service';

@Component({
    selector: 'app-client-dashboard',
    templateUrl: './client-dashboard.component.html',
    styleUrls: ['./client-dashboard.component.less']
})
export class ClientDashboardComponent implements OnInit, OnDestroy {

    zones: Zone[] | null = null;
    private subscription: Subscription;
    currentCompany: any = null
    currentCompanyId: string | null = null

    navLinks: any[];
    activeLinkIndex = -1;

    constructor(private zoneService: ZoneService,
        private router: Router,
        private location: Location,
        private route: ActivatedRoute,
        private dataService: DataService,
        public dialog: MatDialog,
        private _api: ApiService,
        public authService: AuthService) {
            this.navLinks = [
                {
                  label: 'Overview',
                  link: './overview',
                  index: 0,
                },
                {
                  label: 'Cycels',
                  link: './cycles',
                  index: 1
                },
                {
                  label: 'Sensors',
                  link: './sensors',
                  index: 2
                },
                {
                  label: 'Appliances',
                  link: './appliances',
                  index: 3
                },
                {
                  label: 'Gateways',
                  link: './gateways',
                  index: 4
                },
              ];

        this.route.params.subscribe(params => {
            this.currentCompanyId = params.id
            this.dataService.updateCompanyId(params.id)
        });
        this.subscription = this.dataService.sharedCompany$.subscribe(company => {
            if(company){
                this.currentCompany = company.name ? company.name: company;
              }else{
                this.currentCompany = company;
              }
        // this.currentCompany = company.name ? company.name : company;
        })

       switch(this.route.snapshot['_urlSegment'].segments[2].path){
        case 'overview':
            this.activeLinkIndex = 0
            break;
        case 'cycles':
            this.activeLinkIndex = 1
            break;
        case 'sensors':
            this.activeLinkIndex = 2
            break;
        case 'appliances':
        this.activeLinkIndex = 3
        break;
        case 'gateways':
        this.activeLinkIndex = 4
        break;
       }
    
    }

    ngOnInit(): void {
        this.getZones();
    }

    ngOnDestroy() {
        this.subscription.unsubscribe();
    }

    addNew(type: string){
        let title = type[0].toUpperCase() + type.slice(1)
        let data: any = {
            type: type,
            company: this.currentCompanyId,
            title: title,
            name: '',
            function: (item) => this.add(type, item)
          }
        
        if(type === 'sensor'){
            data = {...data, zone: this.zones}
        }
        
        const dialogRef = this.dialog.open(AddDialogComponent, {
            disableClose: true,
            data: data
            
          });
      
          dialogRef.afterClosed().subscribe(result => {
            if (result === undefined) return;
            setTimeout(() => result.name);
            // this.create['company'] = {}
            // this.fetchData();
            this.getZones();
          });
    }

    add(type: string, data: any) {
        if(type === 'cycle'){
            return this._api.post<any>(`/zone/${data.zone}/${type}`,
            {
                strainName: data.name,
                state: data.currentState,            
                grow: {plantsQuantity: data.plantsQuantity},
                // plantsQuantity: data.grow.plantsQuantity,
                cycleTimes: data.cycleTimes,
                isAllSensors: data.isAllSensors,
                sensors: data.sensors,
                harvest: data.harvest ? data.harvest : {}
            });
        }
        return this._api.post<any>(`/${type}`, data);
    }

    getZones(): void {
        // let companyId = this.currentCompany ? this.currentCompany._id : this.currentCompanyId
        this.zoneService.companyZones(this.currentCompanyId).subscribe((response: Zone[]) => {

            this.zones = response;
            if(this.zones.length === 0){
            }
            let listOfZones = this.zones.map(x => {
                return { _id: x._id, name: x.name }
            })

            localStorage.setItem('zoneList', JSON.stringify(listOfZones));
            if(this.zones.length){
                this.currentCompany = this.zones[0]['company']
                let company = {_id: this.zones[0]['company']._id, name: this.zones[0]['company'].name}
                localStorage.setItem('currentCompany', JSON.stringify(company));
                this.dataService.updateCompany(this.zones[0]['company'].name)
                this.dataService.updateCompanyId(this.zones[0]['company']._id)
            }

            let sensors: any  = []
            this.zones.forEach(zone => {
                zone.reducedSensors = Sensor.breakdownSensors(zone.sensors, zone.alerts);
                zone.alertSensors = Sensor.reduceSensorAlerts(zone.sensors, zone.alerts);
                zone.alertAppliances = Sensor.reduceApplianceAlerts(zone.sensors, zone.alerts, ['status']);

                zone.sensors.forEach(sensor => {
                    sensor.zone = zone._id
                    sensors.push(sensor)
                });

                
            })

            this.dataService.updateSensors(sensors)
            this.dataService.updateZones(this.zones);

        }, (err) => {
            switch (err.status) {
                case 401:
                    //   this._logger.info('Incorrect');
                    break;
            }
        }, () => {
            //   this._logger.info('Completed')
        });
    }

    goBack(){
        localStorage.setItem('currentCompany', JSON.stringify(null));
        this.router.navigate(['clients'])
        this.dataService.updateCompany(null)
        this.dataService.updateCompanyId(null)
    }

    updateActiveLinkIndex(index){
        this.activeLinkIndex = index
    }


}
